module.exports = __webpack_public_path__ + "static/media/Boreal-Besties5.b7586819.jpg";